import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useJamaah } from "@/context/JamaahContext";
import { errMsg } from "@/lib/api";
import { Field } from "./JamaahFields";

export const LoginForm = ({ onRegister, onForgot }) => {
  const { login } = useJamaah();
  const navigate = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(phone, password);
      navigate("/portal");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="space-y-4" data-testid="jamaah-login-form">
      <Field id="login-phone" label="No. HP / WA" required>
        <Input id="login-phone" type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required placeholder="081234567890" data-testid="jamaah-login-phone-input" />
      </Field>
      <Field id="login-pass" label="Kata Sandi" required>
        <Input id="login-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" data-testid="jamaah-login-password-input" />
      </Field>
      {error && <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid="jamaah-login-error">{error}</p>}
      <Button type="submit" className="w-full rounded-full h-11 emerald-bg hover:bg-[#145c48]" disabled={loading} data-testid="jamaah-login-submit-btn">
        {loading ? <Loader2 className="animate-spin" size={18} /> : "Masuk"}
      </Button>
      <div className="flex flex-wrap items-center justify-between gap-2 text-sm pt-1">
        <p className="text-slate-600">Belum punya akun? <button type="button" onClick={onRegister} className="font-semibold text-emerald-800 hover:underline" data-testid="login-goto-register">Daftar Jamaah</button></p>
        <button type="button" onClick={onForgot} className="text-emerald-800 hover:underline" data-testid="login-goto-forgot">Lupa kata sandi?</button>
      </div>
    </form>
  );
};
